import { useAuth } from './useAuth'
import { useFamily, useFamilyMembers } from './useFamily'
import { usePermissions } from './usePermissions'

/**
 * Helper hook for consistent member filtering across pages.
 *
 * - Parents see their own data (need their own user ID for health APIs)
 * - Caregivers/Viewers need to specify which parent to view
 */
export function useRoleBasedMemberId() {
  const { user } = useAuth()
  const { selectedFamilyId } = useFamily()
  const { selectedMemberId, selectedMember, parentMembers } = useFamilyMembers(selectedFamilyId)
  const { isParent } = usePermissions()

  return {
    // For API calls: member_id for filtering (kept for alerts and other APIs)
    memberId: isParent ? undefined : selectedMemberId ?? undefined,
    // For health APIs: need the user ID (not member ID)
    // Parents use their own user ID, caregivers use the selected member's user ID
    parentUserId: isParent ? user?.id : selectedMember?.user.id,
    // For UI: show member selector only for non-parents
    shouldShowMemberSelector: !isParent && parentMembers.length > 0,
    // Convenience: pass through familyId
    familyId: selectedFamilyId,
    // Whether a member is selected (useful for showing empty states)
    hasMemberSelected: isParent || !!selectedMemberId,
  }
}
